/**
 * Get the node where we can insert skip-to links.
 *
 * We cannot mount multiple React things on the same node, so we need to
 * insert nodes and mount on those.
 *
 * This creates the mounting point for us. The node itself is mounted by our
 * SiteHeader.
 */
export const getSkipToTargetMount = (): HTMLElement => {
    const NODE_ID = "skip-to-target-mount";
    const existingNode = document.getElementById(NODE_ID);
    if (existingNode) {
        return existingNode;
    }

    const skipToMountingNode = document.createElement("div");
    skipToMountingNode.id = NODE_ID;
    // We don't want this node to be tabbable.
    skipToMountingNode.tabIndex = -1;
    return skipToMountingNode;
};
